import { connect } from 'react-redux';

import {
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getCustomCashbackIconUrl,
  getIsHotelOnly,
  getIsMobile,
} from 'src/store/view/selectors';

// Actions:
import { submitPackageAction } from '../../store/actions/order';
import { setPaymentMethod } from '../../../../store/payment/reducer';

import {
  getOriginalPackageOrderBonuses,
  getOrderIsCreated,
  getRemainingPaymentAmount,
  getDiscountMethods,
} from '../../store/selectors/order';
import {
  getPaymentMethod,
  getPaymentMethodList,
} from '../../../../store/payment/selectors';

import Payment from './Payment';

const mapStateToProps = (state) => ({
  customCashbackIconURL: getCustomCashbackIconUrl(state),
  customCashbackText: getCashbackLabel(state),
  customCashbackTooltipText: getCashbackTooltip(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  bonuses: getOriginalPackageOrderBonuses(state),
  paymentsMethods: getPaymentMethodList(state),
  discountMethods: getDiscountMethods(state),
  orderPayment: getPaymentMethod(state),
  isCreated: getOrderIsCreated(state),
  priceWithDiscount: getRemainingPaymentAmount(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  submit: submitPackageAction,
  changeOrderPayment: setPaymentMethod,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
